import 'bootstrap';
import { createApp } from 'vue';
import App from "../components/App.vue";
import router from "../routes/index.js";
import AOS from 'aos';
import '../scss/styles.one3design.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const eventBus = createApp(App)

createApp(App).use(router).mount('#app');


// init dependencies
AOS.init();